import * as z from "@-/com.npmjs.zod";
import { morphemePinyinMorphemeSliceSchema } from "#morpheme-pinyin-morpheme-slice-schema";

/** One pronunciation row on a card: tone-marked key plus optional gloss and mnemonic for that reading. */
export const cardPinyinListEntrySliceSchema = morphemePinyinMorphemeSliceSchema.extend({
  toneNumbersPinyin: z.string(),
  /**
   * The words this reading appears in; `exhaustive` when it occurs in no other word (会 kuài:
   * only in 会计).
   */
  usage: z.object({ exhaustive: z.boolean(), words: z.array(z.string()) }).nullish(),
});
